import { ConflictError, ApiError } from '../data/errors'
import type { Aggregator } from '../domain/types'

/** Snapshot mínimo da view usada para refetchar o detalhe correntemente aberto. */
export interface RunActionView {
  name: string
  aggId?: string | null
}

/** Resultado do reload: itens da lista + (quando a tela de detalhe está aberta) o detalhe
 *  já refetched em paralelo — D-1: o runAction reusa esse detalhe em vez de chamar
 *  ds.getJourney duplicado. */
export interface ReloadResult {
  items: Aggregator[]
  detail?: Aggregator | null
}

export interface RunActionDeps {
  getView: () => RunActionView
  reload: () => Promise<ReloadResult>
  setDetailAgg: (value: Aggregator | null) => void
  setActionPending: (key: string, value: boolean) => void
  toast: (message: string, tone?: 'success' | 'warning' | 'error', code?: string | null, action?: { label: string; fn: () => void }) => void
}

/** Executa uma action, refetcha lista (+ detalhe aberto, junto no reload) e trata erro com
 *  os mesmos toasts em todos os ramos; rollback roda em `ApiError`/genérico igual. */
export function createRunAction(deps: RunActionDeps) {
  const { getView, reload, setDetailAgg, setActionPending, toast } = deps

  return async (fn: () => Promise<void>, ok?: () => void, pendingKey?: string): Promise<void> => {
    if (pendingKey) {setActionPending(pendingKey, true)}
    try {
      await fn()
      const view = getView()
      const result = await reload()
      if (view.name === 'detalhes' && view.aggId && result.detail !== undefined) {setDetailAgg(result.detail ?? null)}
      ok?.()
    }
    catch (e) {
      if (e instanceof ApiError && e.status === 401) {return}
      if (e instanceof ConflictError) { toast(e.message, 'error') }
      else if (e instanceof ApiError) { toast(e.message, 'error') }
      else { toast('Ocorreu um erro. Tente novamente.', 'error') }
      void reload()
    } finally {
      if (pendingKey) {setActionPending(pendingKey, false)}
    }
  }
}
